import { render, staticRenderFns } from "./CustomAudio.vue?vue&type=template&id=5d71a1ae&scoped=true&lang=pug&"
import script from "./CustomAudio.vue?vue&type=script&lang=js&"
export * from "./CustomAudio.vue?vue&type=script&lang=js&"
import style0 from "./CustomAudio.vue?vue&type=style&index=0&id=5d71a1ae&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d71a1ae",
  null
  
)

export default component.exports